<brightside-web-transaction-history
  [transactionsHistory]="transactionsHistory"
  [hasMoreTransactions]="hasMoreTransactions"
  (loadMoreClicked)="loadMore()">
  <brightside-web-account-header
    *ngIf="(currentAccountInfo | async) as account"
    [title]="account.accountDisplayName"
    [balance]="account.availableBalance">
  </brightside-web-account-header>
</brightside-web-transaction-history>
